import { useEffect, useState } from "react";
import { getTask } from "../../../Services/taskServices";
import toast from "react-hot-toast";
import { RESET_PAGINATION } from "../../../Constants/Strings";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";
import { VIEW_DETAILS } from "../../../routes";
import { Loader, Spinner } from "../../../Components/Common";
import { getUniqueDataById } from "../../../Utils";
import { ERROR, NOT_ASSIGNED, STATUS } from "../constant";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";

const UserTask = ({ filters = {} }) => {
  const [taskData, setTaskData] = useState([]);
  const [pagination, setPagination] = useState(RESET_PAGINATION);
  const [loading, setLoading] = useState(false);
  const [paginationLoading, setPaginationLoading] = useState(false);
  const navigate = useNavigate();

  const getPaginationData = () => {
    if (pagination.offset > pagination.count) return;
    const finalParams = { ...pagination };
    fetchTaskDetails(finalParams);
  };

  const fetchTaskDetails = async (finalParams, isInitial = false) => {
    if (!isInitial) {
      setPaginationLoading(true);
    }
    try {
      const cleanedFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, val]) => val !== "")
      );

      const response = await getTask({ ...finalParams, ...cleanedFilters });

      if (response.status === 200) {
        if (isInitial) {
          setTaskData(response.data.results || []);
        } else {
          setTaskData((prevData) =>
            getUniqueDataById(prevData, response.data.results)
          );
        }

        setPagination((prevData) => ({
          ...prevData,
          count: response.data.count,
          offset: isInitial
            ? response.data.results.length
            : prevData.offset + response.data.results.length,
        }));
      }
    } catch (error) {
      const msg = extractErrorMessage(error) || ERROR.TASK;
      toast.error(msg);
    } finally {
      setPaginationLoading(false);
    }
  };


  useEffect(() => {
    fetchTaskDetails({ ...RESET_PAGINATION }, true, filters);
  }, [filters]);

  useEffect(() => {
    setLoading(true);
    fetchTaskDetails({ ...RESET_PAGINATION }, true).finally(() =>
      setLoading(false)
    );
  }, []);

  return (
    <div className="py-4 px-4 relative">
      {loading && (
        <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-50">
          {" "}
          <Loader />{" "}
        </div>
      )}
      {!loading && taskData.length === 0 && (
        <div className="text-center text-gray-500 py-10">No tasks found...</div>
      )}
      {!loading && taskData.length > 0 && (
        <InfiniteScroll
          dataLength={taskData.length}
          next={getPaginationData}
          hasMore={pagination.offset < pagination.count}
          scrollableTarget="scrollableContainer"
        >
          <div
            className="md:h-[60vh] h-[70vh] overflow-x-auto overflow-y-auto"
            id="scrollableContainer"
          >
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 overflow-x-auto">
              {taskData.map((task) => (
                <div
                  key={task.id}
                  className=" bg-white shadow-md rounded-2xl border border-gray-200 p-4 flex flex-col gap-2 hover:shadow-lg transition-shadow overflow-x-auto cursor-pointer"
                  onClick={() =>
                    navigate(`${VIEW_DETAILS.replace(":taskId", task.id)}`)
                  }
                >
                  <div className="flex justify-between items-center">
                    <h3 className="text-lg font-semibold text-gray-800 truncate md:max-w-[250px] max-w-[150px]">
                      {task.title}
                    </h3>
                    <span
                      className={`text-xs font-medium px-2 py-1 rounded-full truncate ${task.status === STATUS.COMPLETED
                        ? "bg-green-100 text-green-700"
                        : task.status === STATUS.IN_PROGRESS
                          ? "bg-blue-100 text-blue-700"
                          : task.status === STATUS.PENDING
                            ? "bg-yellow-100 text-yellow-700"
                            : task.status === STATUS.CANCELLED
                              ? "bg-red-100 text-red-700"
                              : task.status === STATUS.CLOSED
                                ? "bg-gray-200 text-gray-800"
                                : "bg-gray-100 text-gray-600"
                        }`}
                    >
                      {task.status
                        .toLowerCase()
                        .split('_')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ')}
                    </span>
                  </div>

                  <div className="text-sm text-gray-600 flex justify-between items-center gap-1">
                    <div className="flex-col items-center text-center gap-1">
                      <div className="flex items-center truncate mx-w-[120px]">
                        <span className="font-bold text-center">
                          Site : {" "}
                        </span>
                        {task.site_details.name}
                      </div>
                      <div className="flex items-center truncate mx-w-[120px]">
                        <span className="font-bold text-center">
                          Assigned to : {" "}
                        </span>
                        {task.assignee_details
                          ? `${task.assignee_details?.first_name} ${task.assignee_details?.last_name}`
                          : NOT_ASSIGNED}
                      </div>
                      <div className="flex items-center truncate mx-w-[120px]">
                        <span className="font-bold text-center">
                          Assigned by : {" "}
                        </span>
                        {task.created_by_details
                          ? `${task.created_by_details?.first_name} ${task.created_by_details?.last_name}`
                          : NOT_ASSIGNED}
                      </div>
                    </div>

                  </div>
                </div>
              ))}
            </div>
          </div>
        </InfiniteScroll>
      )}
      {paginationLoading && (
        <div className="flex absolute top-0 left-0 h-full w-full justify-center items-center">
          <Spinner size={30} />
        </div>
      )}
    </div>
  );
};

export default UserTask;
